import {


    useMemo,


} from "react";
import {
    FolderOpen,
    Plus,
    LibraryBig,
    Pin,
    Star,
    Folder
} from "lucide-react";

import MediaSidebarSection
from "./MediaSidebarSection";

export default function MediaSidebar({
    lists, loading,
    selectedList,

    onSelect,

    onCreate,

    onMenu

}){

  

    const pinned=

        useMemo(

            ()=>lists.filter(

                l=>l.pinned

            ),

            [lists]

        );

    const favorites=

        useMemo(

            ()=>lists.filter(

                l=>

                    !l.pinned &&

                    l.favorite

            ),

            [lists]

        );

    const normal=

        useMemo(

            ()=>lists.filter(

                l=>

                    !l.pinned &&

                    !l.favorite

            ),

            [lists]

        );

    return(
        <div>

        <div >

   

    <div

        className={`sidebar-item ${
            selectedList === null ? "active" : ""
        }`}

        onClick={() => onSelect?.(null)}

    >

        <div className="sidebar-left">

            <FolderOpen size={18}/>

            <span>All Files</span>

        </div>

    </div>

    <div className="sidebar-divider"/>

    {
        loading
            ? Array.from({ length: 8 }).map((_, i) => (
                <div
                    key={i}
                    className="sidebar-loading"
                />
            ))
            : (
                <>
                    <MediaSidebarSection
                        title="Pinned"
                        icon={<Pin size={16}/>}
                        rows={pinned}
                        selectedList={selectedList}
                        onSelect={onSelect}
                        onMenu={onMenu}
                    />

                    <MediaSidebarSection
                        title="Favorites"
                        icon={<Star size={16}/>}
                        rows={favorites}
                        selectedList={selectedList}
                        onSelect={onSelect}
                        onMenu={onMenu}
                    />

                    <MediaSidebarSection
                        title="Lists"
                        icon={<Folder size={16}/>}
                        rows={normal}
                        selectedList={selectedList}
                        onSelect={onSelect}
                        onMenu={onMenu}
                    />
                </>
            )
    }

    </div><div className="sidebar-footer">

        <button

            className="create-list-btn"

            onClick={onCreate}

        >

            <Plus size={18}/>
            Create List

        </button>

    </div>
    
    </div>

    );

}